<template>
    <div class="row">
        <div class="col-12 mb-2">
            <input type="text" class="form-control required rounded" maxlength="200" v-model="filho.nome" placeholder="Nome completo do filho(a)"/>
        </div>
        <div class="col-12">
            <input type="date" class="form-control required rounded" maxlength="200" v-model="filho.dataNascimento" placeholder="Nome completo do filho(a)"/>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Filho',
    props: ['filho']
}

</script>